import { createFileRoute } from '@tanstack/react-router';

import { R2View } from '../../raporty/r2/R2View';

export const Route = createFileRoute('/raporty/r2')({
  component: R2View,
});
